import { getCourseClassifyList, moveCourseClassify } from "../api/userMG";

export default {
  data() {
    return {
      moveParentDialogVisible: false,
      moveParentSaving: false,
      moveParentOptions: [],
      moveParentPath: [],
      moveParentRow: null,
      moveParentListId: null,
      moveParentProps: {
        value: "id",
        label: "title",
        children: "children",
        lazy: true,
        checkStrictly: false,
        lazyLoad: (node, resolve) => this.loadMoveParentChildren(node, resolve),
      },
    };
  },
  methods: {
    openMoveParent(row, listId) {
      if (!row || !row.id) return;
      this.moveParentRow = row;
      this.moveParentListId = listId;
      this.moveParentPath = [];
      this.moveParentOptions = [];
      this.moveParentDialogVisible = true;
    },

    async loadMoveParentChildren(node, resolve) {
      const level = node && node.level ? node.level : 0;
      const superiorId = level > 0 ? node.value : 0;
      const targetDepth = Number(this.moveParentDepth || 1);
      try {
        const res = await getCourseClassifyList({
          type: 2,
          superiorId,
          classifyType: Number(this.moveParentClassifyType || 0),
        });
        if (!res || res.code != 200) throw new Error("分类加载失败");
        const list = (res.data && res.data.list) || [];
        resolve(list.map((item) => ({
          id: item.id,
          title: item.title,
          leaf: level + 1 >= targetDepth,
        })));
      } catch (e) {
        resolve([]);
        this.$message.error("分类加载失败，请稍后再试！");
      }
    },

    async confirmMoveParent() {
      const path = Array.isArray(this.moveParentPath) ? this.moveParentPath : [];
      const targetDepth = Number(this.moveParentDepth || 1);
      const row = this.moveParentRow;
      const targetId = path.length ? path[path.length - 1] : null;
      if (!row || !targetId || path.length !== targetDepth) {
        this.$message.warning("请选择正确的上级分类！");
        return;
      }
      if (String(targetId) === String(row.id)) {
        this.$message.warning("不能选择当前分类作为上级！");
        return;
      }

      this.moveParentSaving = true;
      try {
        const res = await moveCourseClassify({ id: row.id, superiorId: targetId });
        if (!res || res.code != 200) {
          this.$message.error((res && res.msg) || "修改上级失败！");
          return;
        }
        this.$message.success(res.msg || "上级分类已修改！");
        this.moveParentDialogVisible = false;
        this.getCourseClassifyList(this.moveParentListId);
      } catch (e) {
        this.$message.error("修改上级失败，请稍后再试！");
      } finally {
        this.moveParentSaving = false;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/courseClassifyMove.js